import { useSyncExternalStore } from "react";
import { useUiStore } from "@web/stores/ui.ts";
import { getLastRequest, subscribeLastRequest } from "./lastRequest.ts";

/** Small corner readout when debug mode is on — last request status + latency. */
export function DebugHud() {
  const debugMode = useUiStore((s) => s.debugMode);
  const last = useSyncExternalStore(subscribeLastRequest, getLastRequest, () => null);

  if (!debugMode || !last) return null;

  const statusLabel = last.status === "network" ? "NET" : String(last.status);
  const ok =
    last.status !== "network" && typeof last.status === "number" && last.status < 400;

  return (
    <div
      className="pointer-events-none fixed top-3 right-3 z-50 rounded-md border border-line bg-panel-elevated/95 px-2.5 py-1.5 font-mono text-xs"
      aria-hidden
    >
      <span className={ok ? "text-accent" : "text-status-cancelled"}>{statusLabel}</span>
      <span className="text-faint"> · {last.ms}ms · </span>
      <span className="text-muted">
        {last.method} {last.path}
      </span>
      {last.errorId && <span className="text-faint"> · {last.errorId}</span>}
    </div>
  );
}
